import PropTypes from "prop-types";
import { Card } from "react-bootstrap";

const CardDisplayComponent = ({
  cardClassName,
  cardBorder,
  moreButton,
  header,
  body,
  footer
}) => {
  return (
    <Card
      className={`${cardClassName || ""} m-1 mb-4 p-4 border-${
        cardBorder || 0
      }`}
    >
      {moreButton && moreButton?.top}
      {header && (
        <Card.Header
          className={`p-3 bg-transparent border-bottom-0 ${
            header?.className || ""
          }`}
        >
          {header?.title && (
            <Card.Title
              className={`mb-0 fs-2 ${header?.title?.className || ""}`}
            >
              {header?.title?.text}
            </Card.Title>
          )}

          {header?.button}
          {header?.element}
        </Card.Header>
      )}

      {body && (
        <Card.Body
          as={body?.as}
          ref={body?.ref}
          className={body?.className || ""}
        >
          {body?.element}
        </Card.Body>
      )}

      {footer && (
        <Card.Footer
          className={`p-3 bg-transparent border-top-0 ${
            footer?.className || ""
          }`}
        >
          {footer?.element}
        </Card.Footer>
      )}
    </Card>
  );
};

CardDisplayComponent.propTypes = {
  cardClassName: PropTypes.string,
  cardBorder: PropTypes.number,
  moreButton: PropTypes.object,
  header: PropTypes.object,
  body: PropTypes.object,
  footer: PropTypes.object
};

export default CardDisplayComponent;
